import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";
import { useT } from "@/i18n/LanguageProvider";

/**
 * HeroTrackWidget — compact tracking search shown in the homepage hero.
 * On submit, navigates to /track?id=… which auto-runs the lookup.
 */
export default function HeroTrackWidget() {
  const t = useT();
  const navigate = useNavigate();
  const [value, setValue] = useState("");
  const w = t.hero.trackWidget;

  const onSubmit = (e) => {
    e.preventDefault();
    if (!value.trim()) {
      navigate("/track");
      return;
    }
    navigate(`/track?id=${encodeURIComponent(value.trim())}`);
  };

  return (
    <div
      className="rounded-2xl bg-white/[0.05] border border-white/15 backdrop-blur-sm p-5 md:p-6"
      data-testid="hero-track-widget"
    >
      <div className="flex items-baseline justify-between gap-3 flex-wrap">
        <p className="text-sm font-semibold text-white tracking-tight">{w.title}</p>
        <p className="text-[11px] uppercase tracking-[0.18em] text-white/55">{w.sub}</p>
      </div>
      <form onSubmit={onSubmit} className="mt-3 flex flex-col sm:flex-row gap-2.5">
        <div className="relative flex-1">
          <Search
            size={16}
            className="absolute left-3.5 top-1/2 -translate-y-1/2 text-white/40 pointer-events-none"
          />
          <input
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={w.placeholder}
            data-testid="hero-track-input"
            className="w-full pl-10 pr-3 py-3 rounded-xl bg-black/25 border border-white/15 text-white placeholder:text-white/35 focus:outline-none focus:border-delfi-red focus:bg-black/40 transition-colors text-sm tracking-wide"
          />
        </div>
        <button
          type="submit"
          data-testid="hero-track-submit"
          className="px-5 py-3 rounded-xl bg-delfi-red text-white font-semibold text-sm hover:bg-delfi-deep transition-colors flex items-center justify-center gap-2"
        >
          {w.button} <ArrowRight size={14} />
        </button>
      </form>
    </div>
  );
}
